import type { Side } from '../../lib/match-snapshot';
import './QuietPlacementTools.css';

/** A fixed material/face sample, never stock, captured discs or the next stone count. */
export function QuietPlacementTools({ game, yourSide, mini = false, staticView = false }: {
  game: 'Renju' | 'Connect6' | 'Reversi'; yourSide?: Side | null; mini?: boolean; staticView?: boolean;
}) {
  if (mini || staticView || (yourSide !== 'First' && yourSide !== 'Second')) return null;
  const tone = yourSide === 'First' ? 'black' : 'white';
  const colour = yourSide === 'First' ? '黒' : '白';
  return <span className={`quiet-placement-tools quiet-placement-tools--${game.toLowerCase()}`}
    role="img" aria-label={`あなたの${colour}・道具の色見本（個数ではありません）`}
    data-testid={`${game.toLowerCase()}-own-tools`} data-tone={tone} data-side={yourSide}>
    {game !== 'Reversi'
      ? <img src={`/generated/vessels/goke-rim-${tone}.png`} alt="" draggable={false} />
      : <><img className="reversi-tool-tray" src="/generated/vessels/reversi-wood-tray.png" alt="" draggable={false} />
          {[0,1].flatMap(column => [0,1,2,3,4].map(layer => <img key={`${column}-${layer}`} className="reversi-tool-disc" style={{ left: `${18+column*37}px`, top: `${29-layer*3}px`, zIndex: layer+1 }} src={`/generated/mix/reversi-disc-${tone}.png`} alt="" draggable={false} />))}</>}
  </span>;
}
